var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiver2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.239,
    height: 60.239,
    viewBox: "0 0 60.239 60.239",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(1.4 1.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke_17",
    "data-name": "Stroke 17",
    d: "M0,28.757A28.72,28.72,0,1,1,28.757,57.439,28.72,28.72,0,0,1,0,28.757Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#33f",
    strokeWidth: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_23",
    "data-name": "Stroke 23",
    d: "M6.37,19.6H.7a.7.7,0,0,1-.7-.7V8.785A8.792,8.792,0,0,1,8.785,0H32.9a.7.7,0,0,1,.7.7,11.822,11.822,0,0,1-3.485,8.414A11.822,11.822,0,0,1,21.7,12.6H21a18.9,18.9,0,0,1-6.521,5.16A18.9,18.9,0,0,1,6.37,19.6ZM8.785,1.4A7.4,7.4,0,0,0,1.4,8.785V18.2H6.363a17.373,17.373,0,0,0,12.1-4.885A17.374,17.374,0,0,0,23.8,1.4ZM25.2,1.4a18.789,18.789,0,0,1-3.164,9.8,10.477,10.477,0,0,0,6.976-2.936A10.479,10.479,0,0,0,32.2,1.4Z",
    transform: "translate(11.919 21.061)",
    fill: "none",
    stroke: "#33f",
    strokeWidth: 1.4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill_21",
    "data-name": "Fill 21",
    d: "M6.37,19.6H.7a.7.7,0,0,1-.7-.7V8.785A8.792,8.792,0,0,1,8.785,0H32.9a.7.7,0,0,1,.7.7,11.822,11.822,0,0,1-3.485,8.414A11.822,11.822,0,0,1,21.7,12.6H21a18.9,18.9,0,0,1-6.521,5.16A18.9,18.9,0,0,1,6.37,19.6ZM8.785,1.4A7.4,7.4,0,0,0,1.4,8.785V18.2H6.363a17.373,17.373,0,0,0,12.1-4.885A17.374,17.374,0,0,0,23.8,1.4ZM25.2,1.4a18.789,18.789,0,0,1-3.164,9.8,10.477,10.477,0,0,0,6.976-2.936A10.479,10.479,0,0,0,32.2,1.4Z",
    transform: "translate(11.919 21.061)",
    fill: "#33f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiver2);
export default __webpack_public_path__ + "static/media/liver_2.89c4b70baed34a540bc378b90a651d47.svg";
export { ForwardRef as ReactComponent };